import * as React from "react";
import ISupplierModel from "../models/ISupplierModel";

const SupplierContext = React.createContext<ISupplierModel>({} as ISupplierModel);

export default SupplierContext;
